import { cacheDel, cacheGet, cacheSet } from '@/utils/listCache'

/**
 * Mixin for client-side list pages that load rows via a method/API.
 * - Shows table skeleton only while fetching (when no cached rows)
 * - Hydrates instantly from session cache, then refreshes in background
 *
 * Usage:
 *   mixins: [listTable],
 *   data: () => ({ items: [], tableLoading: false }),
 *   methods: {
 *     get_list() {
 *       return this.loadTable({
 *         cacheKey: 'products:brands',
 *         fetch: () => axios.post(...).then(r => r.data),
 *         map: (data) => (data.orders || []).map(...),
 *       })
 *     }
 *   }
 */
export default {
  data() {
    return {
      tableLoading: false,
    }
  },
  methods: {
    loadTable({ cacheKey, fetch, map, onLoaded, ttlMs } = {}) {
      if (typeof fetch !== 'function') return Promise.resolve()

      const apply = (payload) => {
        const rows = typeof map === 'function' ? map(payload) : (payload || [])
        this.items = Array.isArray(rows) ? rows : []
        if (typeof onLoaded === 'function') onLoaded(payload, this.items)
        return this.items
      }

      const cached = cacheKey ? cacheGet(cacheKey) : null
      if (cached != null) {
        apply(cached)
        this.tableLoading = false
      } else {
        this.tableLoading = true
      }

      return Promise.resolve()
        .then(() => fetch())
        .then((payload) => {
          apply(payload)
          if (cacheKey) cacheSet(cacheKey, payload, ttlMs)
          return payload
        })
        .catch((err) => {
          console.log(err)
          throw err
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    bustTableCache(cacheKey) {
      if (cacheKey) cacheDel(cacheKey)
    },
  },
}
